"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditMarkdown = exports.RenderMarkdown = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_markdown_1 = require("react-markdown");
function LinkRenderer(props) {
    return (React.createElement("a", { href: props.href, target: "_blank" }, props.children));
}
var RenderMarkdown = function (props) { return (React.createElement("div", { className: 'element-row markdown' },
    props.element.description && (React.createElement("div", null,
        React.createElement("b", null, props.element.description))),
    React.createElement(react_markdown_1.default, { children: props.element.value, className: 'markdown-text', components: {
            a: function (props) { return (React.createElement(LinkRenderer, __assign({}, props)) // All other links
            ); }
        } }))); };
exports.RenderMarkdown = RenderMarkdown;
var EditMarkdown = function (props) { return (React.createElement("div", { className: 'element markdown' },
    React.createElement("div", { className: 'description' },
        React.createElement("label", null, (0, translation_1.getLocalization)('dashboardElements/modal/markdownTextDescription')),
        React.createElement(sok_ui_1.TextInput, { value: props.element.description || '', placeholder: (0, translation_1.getLocalization)('dashboardElements/modal/addMarkdownTextDescription'), disabled: props.saveStatus === 'FETCHING', onChange: function (_a) {
                var value = _a.target.value;
                return props.updateElement(props.i, 'description', value);
            } }),
        props.errors !== null &&
            props.errors["element-".concat(props.i, "-description")] && (React.createElement("p", { className: 'validation-error' }, props.errors["element-".concat(props.i, "-description")][0]))),
    React.createElement("div", null,
        React.createElement("div", { className: 'text' },
            React.createElement("label", null, (0, translation_1.getLocalization)('dashboardElements/modal/markdownText')),
            React.createElement(sok_ui_1.TextInput, { type: 'textarea', rows: 4, value: props.element.value, placeholder: (0, translation_1.getLocalization)('dashboardElements/modal/addMarkdownText'), disabled: props.saveStatus === 'FETCHING', onChange: function (_a) {
                    var value = _a.target.value;
                    return props.updateElement(props.i, 'value', value);
                } }),
            props.errors !== null && props.errors["element-".concat(props.i, "-value")] && (React.createElement("p", { className: 'validation-error' }, props.errors["element-".concat(props.i, "-value")][0]))),
        React.createElement("div", { className: 'remove', onClick: function () {
                return props.saveStatus !== 'FETCHING' && props.removeElement(props.i);
            } },
            React.createElement(sok_ui_1.Icon, { className: 'fa-times-circle' }))))); };
exports.EditMarkdown = EditMarkdown;
